<template>
    <Screen>
        <AppBar
            title="Manage blissdom sections"
            :description="`Add or update BIBO app blissdom sections`"
            :showBackButton="false"
        >
            <inertia-link
                :href="$route('admin.blissdom.sections.create')"
                class="btn btn-sm btn-primary"
            >
                <i class="fa fa-plus"></i>
                <span class="d-none d-app-inline">Add new</span>
            </inertia-link>
        </AppBar>
        <Breadcrumbs title="Blissdom Categories" />
        <div class="card">
            <div class="card-body">
                <SearchBar
                    @onSubmit="searchSubmit"
                    @onClear="searchCleared"
                    v-model="searchInput"
                />
                <div class="table-responsive" v-if="data.data.length > 0">
                    <table class="table mb-0">
                        <thead class="thead-light">
                            <tr>
                                <th>#</th>
                                <th>Icon</th>
                                <th>Name</th>
                                <th>Category</th>
                                <th>Sort order</th>
                                <th>Status</th>
                                <th>Is Premium</th>
                                <th>Created</th>
                                <th>Updated</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, i) in data.data" :key="item.id">
                                <td>
                                    {{
                                        i +
                                        1 +
                                        (data.meta.current_page - 1) *
                                            data.meta.per_page
                                    }}
                                </td>
                                <td>
                                    <img
                                        v-lazy="
                                            item.icon ||
                                            asset('images/blissdom/default.png')
                                        "
                                        :alt="item.name"
                                        class="preview-img-sm"
                                        width="50"
                                        height="50"
                                        style="background-color: #f1f1f1"
                                    />
                                </td>
                                <th style="max-width: 220px">
                                    <div>{{ item.name }}</div>
                                </th>
                                <th style="max-width: 220px">
                                    <div>
                                        {{
                                            item.category && item.category.name
                                                ? item.category.name
                                                : "-"
                                        }}
                                    </div>
                                </th>
                                <td>{{ item.sort_order }}</td>
                                <th>
                                    <StatusSwitch
                                        :dataid="item.id"
                                        :status="item.isactive"
                                        action="blissdomSectionStatus"
                                    />
                                </th>
                                <th>
                                    <StatusSwitch
                                        :dataid="item.id"
                                        :status="item.is_premium"
                                        labelText="Premium/Free"
                                        action="blissdomSectionPremiumStatus"
                                    />
                                </th>
                                <td>{{ item.created_at_human || "-" }}</td>
                                <td>{{ item.updated_at_human || "-" }}</td>
                                <td>
                                    <inertia-link
                                        class="btn btn-sm btn-light"
                                        :href="
                                            $route(
                                                'admin.blissdom.sections.edit',
                                                {
                                                    id: item.id,
                                                }
                                            )
                                        "
                                    >
                                        Update
                                    </inertia-link>
                                    <button
                                        class="btn btn-sm btn-danger"
                                        @click.prevent="deleteThis(item.id)"
                                    >
                                        Delete
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <NoData title="No blissdom sections added yet" v-else>
                    <inertia-link
                        :href="$route('admin.blissdom.sections.create')"
                        class="btn btn-primary"
                    >
                        <i class="fa fa-plus"></i> Add new
                    </inertia-link>
                </NoData>
                <Pagination :rawData="data.meta" :onClick="pageChange" />
            </div>
        </div>
    </Screen>
</template>
<script>
export default {
    components: {},
    props: {
        data: {
            type: [Array, Object],
            default: () => [],
        },
        search: {
            type: String,
            default: "",
        },
    },
    watch: {
        search: {
            immediate: true,
            handler(value) {
                this.searchInput = value;
            },
        },
    },
    data() {
        return {
            searchInput: "",
        };
    },
    mounted() {},
    methods: {
        searchSubmit(search) {
            this.$root.$emit("hold-transition", null);
            this.$inertia.visit(
                this.$route(this.$route().current(), {
                    search: search,
                    page: 1,
                })
            );
        },
        searchCleared() {
            this.$root.$emit("hold-transition", null);
            this.$inertia.visit(
                this.$route(this.$route().current(), {
                    search: "",
                    page: 1,
                })
            );
        },
        pageChange(page) {
            this.$root.$emit("hold-transition", null);
            this.$inertia.visit(
                this.$route(this.$route().current(), {
                    page: page,
                    search: this.searchInput,
                })
            );
        },
        async deleteThis(id) {
            this.$root.$emit("confirmModal", {
                title: "Do you want to delete this section?",
                message: "You won't be able to revert this!",
                confirmText: "Yes, delete it!",
                onConfirm: () => {
                    this.$root.$emit("hold-transition", null);
                    this.$inertia.delete(
                        this.$route("admin.blissdom.sections.delete", {
                            id: id,
                        })
                    );
                },
            });
        },
    },
    computed: {},
};
</script>
<style lang="scss" scoped>
.preview-img-sm {
    width: 60px;
    height: 60px;
    object-fit: cover;
}
</style>
